"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.negateMeasure = void 0;
/**
 * @summary Negates a `Measure`.
 *
 * Negates the value of a `Measure`. The unit and all other fields remain untouched.
 *
 * @param {Measure} item
 * @returns {Measure}
 *
 * @example
 * const negative = negateMeasure(positive);
 */
function negateMeasure(item) {
    return {
        ...item,
        value: -item.value,
    };
}
exports.negateMeasure = negateMeasure;
